var React = require('react');

function ArrowRightShort (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"white","fillRule":"evenodd"},[React.createElement("path",{"d":"M16.16064 35.23012a2.56971 2.57066 0 010-3.64006l13.6115-13.6028-13.6115-13.60508a2.57862 2.57957 0 113.6547-3.64006l15.41829 15.42397a2.56971 2.57066 0 010 3.64006L19.81535 35.23012a2.56971 2.57066 0 01-3.63872 0z","key":0}),React.createElement("path",{"d":"M0 17.98726a2.56971 2.57066 0 012.56971-2.57066h25.69714a2.56971 2.57066 0 010 5.14132H2.56971a2.56971 2.57066 0 01-2.5697-2.57066z","key":1})]));
}

ArrowRightShort.defaultProps = {"width":"10","height":"10","viewBox":"0 0 36 36"};

module.exports = ArrowRightShort;

ArrowRightShort.default = ArrowRightShort;
